module.exports = __webpack_public_path__ + "/build/web/images/exclusive-collection.a79ea00d04c67c3dc9868ffa806aa660.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/exclusive-collection.jpg
// module id = 127
// module chunks = 13